module.exports = __webpack_public_path__ + "static/media/j.a6c32c6d.png";